import React from 'react';
import PropTypes from 'prop-types';

import '../PrintTemplate.css';
import SectionSurveyPrint from './SectionSurveyPrint';

// react-print requires class based function
// eslint-disable-next-line react/prefer-stateless-function
class SurveyTemplate extends React.Component {
  render() {
    const { trial, submission } = this.props.data;
    const { sections } = trial.survey.payload;
    const { sections: sectionsSubmission } = submission;
    return (
      <div>
        {sections.map((section, sectionIndex) => (
          <SectionSurveyPrint
            // eslint-disable-next-line react/no-array-index-key
            key={sectionIndex}
            section={section}
            trialName={trial.name}
            sectionIndex={sectionIndex}
            answers={sectionsSubmission[sectionIndex]}
          />
        ))}
      </div>
    );
  }
}

export default SurveyTemplate;

SurveyTemplate.propTypes = {
  data: PropTypes.shape({
    trial: PropTypes.shape({
      name: PropTypes.string,
      survey: PropTypes.shape(PropTypes.object),
    }),
    submission: PropTypes.shape({
      sections: PropTypes.array,
    }),
  }).isRequired,
};
